module.exports = __webpack_public_path__ + "src/assets/img/moslenta.c8fc769f.jpg";